module.exports = __webpack_public_path__ + "assets/img/arrow.9ae18e7c.svg";